import Vue from 'vue'
import App from './App.vue'
import store from './store'
import Socket from '@/plugins/Socket'
import Auth from '@/plugins/Auth'
import Modals from '@/plugins/Modals'
import router from './router'
import { iconsSet as icons } from '@/assets/icons/icons.js'
import * as components from '@/components'
import * as coreuiComponents from '@/coreui.components'
import DatePicker from 'vue2-datepicker'
import VueMask from 'v-mask'
import 'vue2-datepicker/index.css'
import URLS from './constants/url'
import CKEditor from '@ckeditor/ckeditor5-vue2';

Vue.component('VDatePicker', DatePicker)

for (const [key, component] of Object.entries(components)) {
  Vue.component(key, component)
}

for (const [key, component] of Object.entries(coreuiComponents)) {
  Vue.component(key, component)
}

Vue.config.productionTip = false
Vue.use(Socket, { baseURL: URLS.socketUrl })
Vue.use(Auth)
Vue.use(Modals)
Vue.use(VueMask)
Vue.use(CKEditor)

new Vue({
  store,
  router,
  icons,
  render: h => h(App)
}).$mount('#app')
